import GlobalStyles from '@mui/material/GlobalStyles';
import type { PropsWithChildren } from 'react';

import { Wrapper } from './PageWrapper.styles.js';

export const PageWrapper = ({ children }: PropsWithChildren<object>) => {
  return (
    <Wrapper>
      <GlobalStyles
        styles={{
          '& html body': {
            overflowY: 'scroll',
          },
        }}
      />
      {children}
    </Wrapper>
  );
};
